import { render, staticRenderFns } from "./THGCarList.vue?vue&type=template&id=f87494fc"
import script from "./THGCarList.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGCarList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports